/* eslint-disable react/no-unknown-property */
import React, { FunctionComponent, PropsWithChildren } from 'react';
import GenericPageLayoutWrapper, { GenericPageLayoutWrapperSize } from '../wrapper/GenericPageLayoutWrapper';

import * as styles from './GenericPageLayoutBar.style';

export type GenericPageLayoutBarProps = PropsWithChildren<{
  wrapperSize?: GenericPageLayoutWrapperSize;
}>;

const GenericPageLayoutBar: FunctionComponent<GenericPageLayoutBarProps> = ({
  wrapperSize,
  children,
}) => (
  <div css={styles.bar}>
    <GenericPageLayoutWrapper
      maxWidth={wrapperSize || GenericPageLayoutWrapperSize.XLARGE}
    >
      {children}
    </GenericPageLayoutWrapper>
  </div>
);

export default GenericPageLayoutBar;
